exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popup{position:fixed;border-radius:5px;width:100%;height:100%;top:0;left:0;right:0;bottom:0;margin:auto;z-index:1001;background:rgba(0,0,0,.1)}.popup .popup-inner{position:absolute;width:400px;left:25%;right:25%;bottom:35%;margin:auto;background:#fff;border:1px solid #777;border-radius:5px;height:auto;z-index:1002}.popup .popup-inner .top-bar{background-color:rgba(0,0,0,.1);border-top-left-radius:5px;border-top-right-radius:5px;border:1px solid #999;margin:0 0 1px;padding:0 5px;height:25px;color:#27638c;font-weight:700}.popup .popup-inner .top-bar div{display:inline-block;line-height:25px}.popup .popup-inner .top-bar .ui-dialog-titlebar-close{float:right;display:inline-block;height:100%}.popup .popup-inner .top-bar .ui-dialog-titlebar-close:hover{cursor:pointer;opacity:.5}.popup .popup-inner .top-bar .ui-dialog-titlebar-close span{margin-top:4px}.popup .popup-inner button:hover{cursor:pointer;opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/less/popup.less
// module id = 1643
// module chunks = 0